export default "__VITE_ASSET__97253e8e__"